<template>
  <div>
    <Head title="Airports" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Airports</li>
      </ol>
    </nav>
    <h1>Airports</h1>

    <!-- <pre>{{ agencies }}</pre> -->

    <div class="d-flex justify-content-between mb-3">
      <search-filter v-model="form.search" @reset="reset" />

      <Link class="btn btn-primary" href="/settings/airports/create">
        <span>Create Airline</span>
      </Link>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>IATA</th>
            <th>Airport Island / City</th>
            <th>Airport Name</th>
            <th>Airport Country</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="airport in airports.data" :key="airport.id">
            <td>
              <Link :href="`/settings/airports/${airport.id}/edit`" tabindex="-1">
                {{ airport.iata }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/airports/${airport.id}/edit`" tabindex="-1">
                {{ airport.island_city }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/airports/${airport.id}/edit`">
                {{ airport.name }}
              </Link>
            </td>
            <td>
              <Link :href="`/settings/airports/${airport.id}/edit`" tabindex="-1">
                {{ airport.country }}
              </Link>
            </td>
          </tr>
          <tr v-if="airports.length === 0">
            <td colspan="2">No airlines found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-3" :links="airports.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    airports: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings/airports', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
